export enum EMPLOYER_SETTINGS_INTEGRATION_TYPE {
  CSV = 'CSV',
  ESOCIAL = 'ESOCIAL',
}
